import { Paper, TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState } from 'react';

export default function StateMultiSelectColumnFilter({ column: { filterValue, setFilter, preFilteredRows, id, Header, parent }, }) {
    const [optionsState, setOptionsState] = useState([]);
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set()
        preFilteredRows.forEach(row => {
            if (typeof row.values[id] === 'boolean') {
                options.add(row.values[id].toString())
            } else {
                options.add(row.values[id])
            }
            if ('stateLabel'===id && 'WIRED' === row.original['secondaryState']) {
                options.add('Átutalva')
                // console.log(id);
            }
        })
        const i = [...options.values()];
        return i;
    }, [id, preFilteredRows])

    React.useEffect(() => {
        // console.log(filterValue);
        // console.log(optionsState);
        if (filterValue) {
            setOptionsState(filterValue);
        } else {
            setOptionsState([]);
        }
    }, [filterValue]);

    
    const onChange = (event, value) => {
        // console.log(optionsState);
        let newValue = [...value];
        setFilter(newValue);
        setOptionsState(newValue);
    };

    const getHeader = () => {
        if (parent && typeof (parent.Header) === 'string') {
            return parent.Header + " " + Header;
        } else {
            return Header;
        }
    }

    // Render a multi-select box
    return (
        <Autocomplete
            multiple
            value={optionsState}
            className='text-column-filter-input'
            id="autocomplete-filter"
            // limitTags={1}
            size='small'
            options={options}
            disableCloseOnSelect
            disablePortal
            onChange={onChange}
            getOptionLabel={(option) => option}
            renderOption={(option, state) => {
                return (
                    <div className='autocomplete-filter-option'>
                        <Checkbox
                            color="primary"
                            className='autocomplete-filter-checkbox'
                            size='small'
                            checked={optionsState.includes(option)}
                        />
                        {option}
                    </div>
                )
            }}
            PaperComponent={DropDownListRenderer}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={getHeader()}
                    InputLabelProps={{ style: { fontSize: 12, top: '2px' } }}
                />
            )}
        />
    )
}

const DropDownListRenderer = ({ children, ...other }) => (
    <div className="dropDownList">
        <Paper {...other} variant='elevation'>
            {children}
        </Paper>
    </div>
);

export function StateMultiSelectFilterFn(rows, id, filterValues) {
    // console.log(id);
    // console.log(filterValues);
    // console.log(rows);
    if (filterValues.length === 0) {
        return rows;
    } else {
        return rows.filter(r => filterValues.includes(r.values[id]) || isWiredRow(r, filterValues, id));
    }
}

const isWiredRow = (r, filterValues, id) => {
    if (filterValues.includes('Átutalva')) {
        return r.original['secondaryState'] && 'PAID' !== r.values[id];
    } else {
        return false;
    }
}